import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {Job} from './_models'

const getBaseUrl = () => {
  let url = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
  if (url === 'http://localhost:3000') url = 'http://localhost:3000/api';
  return url;
}
const API_URL = getBaseUrl() + '/job'

const createJob = (job: Job): Promise<Job | undefined> => {
  if (job.title && !job.slug) {
    job.slug = job.title.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-' + Date.now();
  }
  const {additional_fields, ...rest} = job as any
  const payload = {...rest, additionalFields: additional_fields || []}
  return axios.post(API_URL, payload)
}

const updateJob = (job: Job): Promise<Job | undefined> => {
  const {additional_fields, ...rest} = job as any
  const payload = {...rest, additionalFields: additional_fields || []}
  return axios.patch(`${API_URL}/${job.id}`, payload)
}

const deleteJob = (jobId: ID): Promise<void> => {
  return axios.delete(`${API_URL}/${jobId}`)
}

export {deleteJob, createJob, updateJob}
